<template>
  <MainLayout>
    <div class="container mw-960" slot="sub-header">
      <div class="row">
        <div class="col-sm-10">
          <nav class="navbar navbar-toggleable navbar-light">
            <ul class="nav navbar-nav">
              <li class="nav-item">
                <router-link to="/publishers/series" class="nav-link typography--body-3">
                  {{ $t('publishers.sub_header.series') }}
                </router-link>
              </li>
              <li class="nav-item active">
                <router-link to="/publishers/non-series-cards" class="nav-link typography--body-3">
                  {{ $t('publishers.sub_header.non_series_cards') }}
                </router-link>
              </li>
            </ul>
          </nav>
        </div>

        <div class="col-sm-2 hidden-xs-down">
          <div class="sub-header-btn-row">
            <router-link class="btn btn-primary new-series-btn float-right" to="/publishers/create-docx-quizzes">
              {{ $t('publishers.create_docx_quizzes.title') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="container mw-960 mt-27" slot="layout-body">
      <div class="row" v-if="loading">
        <div class="col-12 text-center">
          <LoadingBounce />
          <div class="typography--body-2 typography--color-disabled pb-5">
            {{ $t('common.loading') }}
          </div>
        </div>
      </div>

      <div class="row" v-else>
        <div class="col-12 text-center mb-5 pb-5" v-if="nonSeriesCardList.length === 0">
          <div class="empty-list-text">
            <div class="typography--body-2 typography--color-disabled"
                 v-html="$t('publishers.no_cards')">
            </div>
          </div>
        </div>

        <div class="col-sm-6 col-md-4 col-lg-3" v-for="card in nonSeriesCardList" v-bind:key="card.id" v-else>
          <div class="card-row">
            <PublisherCardView
              v-bind:card="card"
              v-bind:is-series-card="false"
              v-on:open-add-to-series-modal="openAddToSeriesModal"
            />
          </div>
        </div>

        <InfiniteLoading :on-infinite="onInfinite" ref="infiniteLoading" class="w-100">
          <div slot="spinner">
            <LoadingBounce></LoadingBounce>
            <div class="typography--body-2 typography--color-disabled pb-5">{{ $t('common.loading') }}</div>
          </div>

          <div slot="no-more" class="col-12 text-center mb-5 pb-5">
          </div>
        </InfiniteLoading>

      </div>
    </div>

    <div slot="modal-area">
      <AddToSeriesModal
        v-if="addToSeriesModalIsShown"
        v-bind:series-list="seriesList"
        v-bind:publisher-id="publisherId"
        v-bind:card-id-for-add-to-series="cardIdForAddToSeries"
        v-on:cancel="closeAddToSeriesModal()"
        v-on:ok="closeAddToSeriesModal()"
      />
    </div>
  </MainLayout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import InfiniteLoading from 'vue-infinite-loading';
  import publisherOnly from '@/mixins/publisherOnly';
  import PublisherCardView from '../components/PublisherCardView';
  import AddToSeriesModal from '../components/AddToSeriesModal';

  export default {
    name: 'non-series-cards',

    mixins: [
      publisherOnly,
    ],

    components: {
      PublisherCardView,
      AddToSeriesModal,
      InfiniteLoading,
    },

    data() {
      return {
        loading: false,
        addToSeriesModalIsShown: false,
        cardIdForAddToSeries: null,
      };
    },

    computed: {
      ...mapGetters([
        'currentPublisherInfo',
        'nonSeriesCardList',
        'seriesList',
      ]),

      publisherId() {
        return this.currentPublisherInfo.id;
      },
    },

    methods: {
      ...mapActions([
        'fetchNonSeriesCards',
      ]),

      openAddToSeriesModal(cardId) {
        this.cardIdForAddToSeries = cardId;
        this.addToSeriesModalIsShown = true;
      },

      closeAddToSeriesModal() {
        this.addToSeriesModalIsShown = false;
        this.cardIdForAddToSeries = null;
      },

      onInfinite() {
        const offset = parseInt(this.nonSeriesCardList.length / 20, 10) * 20;
        const limit = 20;
        const params = {
          publisher_id: this.publisherId,
          offset,
          limit,
        };

        return this.fetchNonSeriesCards(params)
          .then((cardList) => {
            if (this.$refs.infiniteLoading) {
              this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded');

              if (cardList.length < limit) {
                this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete');
              }
            }
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/app/publishers/views/NonSeriesCards.vue